import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SelectedRange {
  minDate: number;
  maxDate: number;
}

interface SelectedRangesState {
  selectedRanges: SelectedRange[];
}

const initialState: SelectedRangesState = {
  selectedRanges: [],
};

const selectedRangesSlice = createSlice({
  name: 'selectedRanges',
  initialState,
  reducers: {
    setSelectedRanges(state, action: PayloadAction<SelectedRange[]>) {
      state.selectedRanges = action.payload;
    },
    addSelectedRange(state, action: PayloadAction<SelectedRange>) {
      state.selectedRanges.push(action.payload);
    },
    clearSelectedRanges(state) {
      state.selectedRanges = [];
    },
  },
});

export const { setSelectedRanges, addSelectedRange, clearSelectedRanges } = selectedRangesSlice.actions;
export default selectedRangesSlice.reducer;
